const view = /*html*/`
    <div id="kt_content_container" class="container-xxl">
        
    
        <div class="form d-flex flex-column mb-6">
            <!--begin::Order details-->
            <div class="card card-flush w-100" style="background-size: cover; background-repeat: no-repeat; background-image: url('assets/media/logos/lobby_header.png');">
                <div style="background-color: rgba(21,21,21,.75);">
                    <div class="d-flex flex-column align-items-center card-body" style="background: linear-gradient(rgba(21,21,21,0),#151515);">
                        <div class="d-flex flex-column text-center align-items-center mb-4">
                            <h4 class="fw-bold text-dark fs-4 lobby-title"></h4>
                            <span id="lobby-badge-type" class="badge text-uppercase text-gray-100"></span>
                        </div>
                        <div class="d-flex w-100">
                            <div class="d-flex w-100 align-items-center">
                                <div class="ms-auto me-4 text-end">
                                    <h4 class="lobby-team-A-name"></h4>
                                    <span id="" class="badge text-gray-800 bg-gray-100 fs-7"><span class="text-gray-700 text-upercase fw-normal fs-8">Rating:</span> <span class="lobby-teamArating"></span>
                                    </span>
                                </div>
                                <div class="d-block m-0">
                                    <div class="symbol symbol-60px">
                                        <img id="lobby-logo-teamA" style="vertical-align: middle" src="assets/media/logos/mixedA.png">
                                    </div>
                                </div>
                            </div>                                
                            <div class="d-flex w-auto flex-column justify-content-center px-4 text-center align-items-center">
                                <span class="badge badge-light-dark text-uppercase mb-2">
                                    <span class="lobby-vs"></span><span class="text-lowercase">v</span><span class="lobby-vs"></span>
                                </span>
                                <span class="text-gray-700 text-nowrap">Best of <span class="lobby-bo">1</span></span>
                            </div>
                            <div class="d-flex w-100 align-items-center">
                                <div class="d-block m-0">
                                    <div class="symbol symbol-60px">
                                        <img id="lobby-logo-teamB" style="vertical-align: middle" src="assets/media/logos/mixedB.png">
                                    </div>
                                </div>
                                <div class="ms-4 me-auto text-start">
                                    <h4 class="lobby-team-B-name"></h4>
                                    <span id="" class="badge text-gray-800 bg-gray-100 fs-7"><span class="text-gray-700 text-upercase fw-normal fs-8">Rating:</span> <span class="lobby-teamBrating"></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer border-0 d-flex flex-wrap justify-content-around align-items-center gap-3 py-4" style="background-color: #1b1b1b;">
                    <div class="d-flex align-items-center flex-grow-1">
                        <!--begin::Symbol-->
                        <div class="symbol symbol-30px me-3">
                            <span class="symbol-label bg-gray-200">
                                <i class="fal fa-heart-rate text-gray-700 fs-3"></i>
                            </span>
                        </div>
                        <!--end::Symbol--> 
                        
                        <!--begin::Info-->
                        <div class="m-0">                            
                            <span class="fw-semibold text-gray-600 d-block fs-8" data-i18n="play.status">Status</span>
                            <span class="fw-bold text-gray-900 fs-7 lobby-server-status"></span>
                        </div>
                        <!--end::Info-->
                    </div>

                    <div class="d-flex align-items-center flex-grow-1">
                        <!--begin::Symbol-->
                        <div class="symbol symbol-30px me-3">
                            <span class="symbol-label bg-gray-200">
                                <i class="fal fa-server text-gray-700 fs-3"></i>
                            </span>
                        </div>
                        <!--end::Symbol--> 
                        
                        <!--begin::Info-->
                        <div class="m-0">                            
                            <span class="fw-semibold text-gray-600 d-block fs-8" data-i18n="play.server">Server</span>
                            <span class="fw-bold text-gray-900 fs-7 lobby-server-region"></span>
                        </div>
                        <!--end::Info-->
                    </div>

                    <div class="d-flex align-items-center flex-grow-1">
                        <!--begin::Symbol-->
                        <div class="symbol symbol-30px me-3">
                            <span class="symbol-label bg-gray-200">
                                <i class="fal fa-signal-4 text-gray-700 fs-3"></i>
                            </span>
                        </div>
                        <!--end::Symbol--> 
                        
                        <!--begin::Info-->
                        <div class="m-0">                            
                            <span class="fw-semibold text-gray-600 d-block fs-8" data-i18n="play.ping">Ping</span>
                            <span class="fw-bold text-gray-900 fs-7 lobby-server-ping"></span>
                        </div>
                        <!--end::Info-->
                    </div>
                </div>
            </div>            
        </div>

        <div class="flex-lg-row row mx-auto justify-content-between flex-wrap mb-7 lobby-actions-container d-none">
            <div class="d-flex justify-content-between align-items-stretch flex-wrap p-0">
                <div class="d-block">
                    <label for="" class="form-label text-muted fs-7 mb-1">Share the lobby url and invite friends</label>
                    <div class="input-group input-group-sm justify-content-center w-auto">
                        <span class="input-group-text bg-transparent w-250px text-gray-700"><span id="lobby-share-url" class="text-nowrap text-truncate text-decoration-underline text-hover-white cursor-pointer"></span></span>
                    <button id="lobby-btn-share" type="button" class="btn btn-copy btn-icon btn-outline btn-outline-light btn-sm" data-clipboard-target="#lobby-share-url">
                            <!--begin::Svg Icon | path: icons/duotune/general/gen054.svg-->
                            <span class="svg-icon svg-icon-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="currentColor"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z" fill="currentColor"></path>
                                </svg>
                            </span>
                            <!--end::Svg Icon-->
                        </button>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-wrap lobby-buttons">
                    
                </div>
            </div>
        </div>

        <div class="flex-lg-row row mx-auto justify-content-between flex-wrap">
            <div class="col-4 px-0 team-A-container">
                <div class="card card-bordered bg-transparent mb-3">
                    <div class="d-flex flex-stack py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="ms-4 mw-150px text-truncate text-nowrap">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">Chino Tuscan</a>
                                <div class="fw-bold text-muted fs-7"><div class="d-flex justify-content-start align-items-center"><div class="d-flex me-2"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-3"></i>
                            </a></div><div class="symbol symbol-20px">
                                <img src="assets/media/roles/awper.png">
                            </div></div>
                            </div>    
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end ms-2">

                            <span class="badge badge-sm badge-secondary text-gray-100"><i class="fas fa-crown text-zyellow"></i></span>
                            
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div>
                <div class="card card-bordered bg-transparent mb-3">
                    <div class="d-flex flex-stack py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="ms-4 mw-150px text-truncate text-nowrap">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">GunGameR</a>
                                   <div class="fw-bold text-muted fs-7"><div class="d-flex justify-content-start align-items-center"><div class="d-flex me-2"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-3"></i>
                            </a></div><div class="symbol symbol-20px">
                                <img src="assets/media/roles/lurker.png">
                            </div></div>
                            </div> 
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end ms-2">
                            <span class="badge badge-sm badge-success text-gray-100"><i class="bi bi-check-circle"></i> Ready</span>
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div><div class="card card-bordered bg-transparent mb-3">
                    <div class="d-flex flex-stack py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="ms-4 mw-150px text-truncate text-nowrap">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">GunGameR</a>
                                    <div class="fw-bold text-muted fs-7"><div class="d-flex justify-content-start align-items-center"><div class="d-flex me-2"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-3"></i>
                            </a></div><div class="symbol symbol-20px">
                                <img src="assets/media/roles/supporter.png">
                            </div></div>
                            </div>
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end ms-2">
                            <span class="badge badge-sm badge-secondary text-success"><span class="spinner-border spinner-border-sm"></span></span>
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div><div class="card card-bordered bg-transparent mb-3">
                    <div class="d-flex flex-stack py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="ms-4 mw-150px text-truncate text-nowrap">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">GunGameR</a>
                                <div class="fw-bold text-muted fs-7"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-5"></i>
                            </a></div>    
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end ms-2">
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="assets/media/ranks/rank_4.png">                                
                            </div>
                            
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div><div class="card card-bordered bg-transparent mb-3">
                    <div class="d-flex flex-stack py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="ms-4 mw-150px text-truncate text-nowrap">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">GunGameR</a>
                                <div class="fw-bold text-muted fs-7"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-5"></i>
                            </a></div>    
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end ms-2">
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="assets/media/ranks/rank_5.png">                                
                            </div>
                            
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="d-flex justify-content-center align-items-center flex-column mb-7">
                    <div class="text-gray-700 fs-6 fw-bold mb-2 lobby-step-container text-center">                        
                    </div>
                    <span class="fs-3 lobby-step-timer teko-header badge bg-primary text-gray-100"></span>
                </div>
                <div class="d-flex justify-content-center align-items-center flex-column lobby-step-content">
                </div>
            </div>
            
            <div class="col-4 px-0 team-B-container">
                <div class="card card-bordered bg-transparent mb-3">
                    <div class="d-flex flex-stack flex-row-reverse py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center flex-row-reverse">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="me-4 mw-150px text-truncate text-nowrap text-end">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">GunGameR</a>
                                <div class="fw-bold text-muted fs-7"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-5"></i>
                            </a></div>    
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end me-2">
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="assets/media/ranks/rank_6.png">                                
                            </div>
                            
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div>
                <div class="card card-bordered bg-transparent mb-3">
                    <div class="d-flex flex-stack flex-row-reverse py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center flex-row-reverse">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="me-4 mw-150px text-truncate text-nowrap text-end">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">GunGameR</a>
                                <div class="fw-bold text-muted fs-7"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-5"></i>
                            </a></div>    
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end me-2">
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="assets/media/ranks/rank_7.png">                                
                            </div>
                            
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div>
            
                <div class="card card-bordered bg-transparent mb-3 bg-gray-100">
                    <div class="d-flex flex-stack flex-row-reverse py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center flex-row-reverse">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="me-4 mw-150px text-truncate text-nowrap text-end">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">GunGameR</a>
                                <div class="fw-bold text-muted fs-7"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-5"></i>
                            </a></div>    
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end me-2">
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="assets/media/ranks/rank_8.png">                                
                            </div>
                            
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div><div class="card card-bordered bg-transparent mb-3 bg-gray-100">
                    <div class="d-flex flex-stack flex-row-reverse py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center flex-row-reverse">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="https://avatars.akamai.steamstatic.com/fef49e7fa7e1997310d705b2a6158ff8dc1cdfeb_full.jpg">
                                
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="me-4 mw-150px text-truncate text-nowrap text-end">
                                <a href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">GunGameR</a>
                                <div class="fw-bold text-muted fs-7"><a href="#" class="btn btn-icon h-auto w-auto btn-color-gray-600 btn-active-color-white">
                                <i class="fab fa-steam fs-5"></i>
                            </a></div>    
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end me-2">
                            <div class="symbol symbol-40px">
                                <img alt="Pic" src="assets/media/ranks/rank_9.png">                                
                            </div>
                            
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div>
                
                
                
                <div class="card card-dashed bg-transparent mb-3 cursor-pointer">
                    <div class="d-flex flex-stack flex-row-reverse py-3 px-3">
                        <!--begin::Details-->
                        <div class="d-flex align-items-center flex-row-reverse">
                            <!--begin::Avatar-->
                            <div class="symbol symbol-40px  align-self-center">
                                <i class="bi bi-plus-circle text-gray-300 fs-2tx"></i>
                            </div>
                            <!--end::Avatar-->
                            <!--begin::Details-->
                            <div class="me-4 mw-150px text-truncate text-nowrap text-end">
                                <span href="user/76561198839753141" data-navigo="" class="fs-6 text-gray-900 mb-2 text-truncate text-nowrap">Take Slot</span>
                                <div class="fw-bold text-muted fs-7"></div>    
                            </div>
                            <!--end::Details-->
                        </div>
                        <!--end::Details-->
                        <!--begin::Lat seen-->
                        <div class="d-flex flex-column align-items-end me-2">
                            <div class="symbol symbol-40px">                                                                
                            </div>                            
                        </div>
                        <!--end::Lat seen-->
                    </div>
                </div>

                
            </div>
            
        </div>

    </div>
`;


export default view;